import { InputAdornment } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Stack } from "@mui/system";
import {
  DateRangePicker,
  LocalizationProvider,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import ConversionsFilter from "./ConversionsFilter";

interface ConversionsSortWrapProps {
  dateType: string;
  endDate: string;
  startDate: string;
}

const ConversionsSortWrap = ({
  dateType,
  endDate,
  startDate,
}: ConversionsSortWrapProps) => {
  const value: [any, any] = [
    dayjs(startDate),
    dayjs(endDate),
  ];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={spacing.Spacing.md.$value}
      >
        <DateRangePicker
          value={value}
          disabled
          onChange={() => {}}
          format="DD/MM/YYYY"
          slots={{ field: SingleInputDateRangeField }}
          slotProps={{
            textField: {
              size: "small",
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarMonthIcon
                      sx={{
                        fontSize: typography.Size.Text.lg.$value,
                        color: colors.GrayLightMode[400].$value,
                      }}
                    />
                  </InputAdornment>
                ),
              },
              sx: {
                width: "75%",
                "& .MuiInputBase-input": {
                  fontSize: typography.Size.Text.sm.$value,
                  lineHeight: typography.Line_height.text.sm.$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: spacing.Radius.md.$value,
                  "&.Mui-focused fieldset": {
                    borderColor: colors.GrayLightMode[300].$value,
                    borderWidth: "1px",
                  },
                },
              },
            },
            actionBar: {
              actions: ["cancel", "accept"],
              sx: {
                "& .MuiButton-root": {
                  color: "secondary.main",
                },
              },
            },
          }}
        />
        <ConversionsFilter
          dateType={dateType}
          endDate={endDate}
          startDate={startDate}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default ConversionsSortWrap;
